import React from 'react';
import Album1 from 'assets/img/album1.jpg';
import Album2 from 'assets/img/album2.jpg';
import Album3 from 'assets/img/album3.jpg';
import Album4 from 'assets/img/album4.jpg';
import withStyles from '@material-ui/core/styles/withStyles';

import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';

const SongCollectionsListItem = ({ data, classes }) => (
  <GridContainer>
    <GridItem style={{ marginTop: '10px' }} xs={4} sm={2} md={2} lg={2}>
      <img
        style={{
          margin: '0px',
          width: '50%',
          borderRadius: '10px 0px 0px 0px',
        }}
        src={Album1}
        alt="Album Artwork"
      />
      <img
        style={{
          margin: '0px',
          width: '50%',
          borderRadius: '0px 10px 0px 0px',
        }}
        src={Album2}
        alt="Album Artwork"
      />
      <img
        style={{
          margin: '0px',
          width: '50%',
          borderRadius: '0px 0px 0px 10px',
        }}
        src={Album3}
        alt="Album Artwork"
      />
      <img
        style={{
          margin: '0px',
          width: '50%',
          borderRadius: '0px 0px 10px 0px',
        }}
        src={Album4}
        alt="Album Artwork"
      />
    </GridItem>
    <GridItem xs={8} sm={10} md={10} lg={10}>
      <p
        style={{
          fontSize: '18px',
          margin: '26px 0px 0px 0px',
        }}
        className={classes.description}
      >
        <b>{data.title}</b>
      </p>
      <p style={{ color: '#AAAAAA' }} className={classes.description}>
        <b>{data.nb} Songs</b>
      </p>
    </GridItem>
  </GridContainer>
);

export default withStyles(Style)(SongCollectionsListItem);
